
import processDateAvailable from "~/mixin/process-date-available-mixin";
import OccasionsMixin from "~/mixin/occasions-fetch-mixin";

export default {
  name: "cal-delivery-date",
  props: {
      deliveryTown: {
        type: Object,
        default: false,
        required: false
      },
      ddModalImg: {
        type: String,
        default: "",
        required: false
      },
      isSubscription: {
        type: Boolean,
        default: false,
        required: false
      },
      setNxtAvailableDate: {
        type: Boolean,
        default: false,
        required: false
      },
      fontVital: {
        type: Boolean,
        default: false,
        required: false
      },
      resetOnCityChange: {
        type: Boolean,
        default: true,
        required: false
      },
      startDate: {
        type: String,
        default: "",
        required: false
      },
      endDate: {
        type: String,
        default: "",
        required: false
      },
  },
  mixins: [processDateAvailable, OccasionsMixin],
  data() {
    return {
      deliveryDate: "",
      nextAvailableDate: "",
      currentLocale: this.$i18n.getLocaleCookie(),
      cutoffs: [],
      closedDays: [],
      unavailableDates: [],
      availableDates: [],
      showDateSelector: false,
      showSlideOver: false,
      disabledDeliveryDate: true,
      occasions: [],
      cutoffCountdown: [],
      disableSaveButton: true,
      displayDeliveryDate: "",
      isLoading: true,
      isDateInputStyle: false,
    };
  },
  computed: {
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
  },
  mounted() {
    this.$nuxt.$on("toggleDeliveryDateSelector", (device) => {
      this.toggleShowDateSelector(device);
    });
  },
  watch: {
    async deliveryTown(newTown, oldTown) {
      if (this.resetOnCityChange && (newTown?.id !== oldTown?.id)) {
        sessionStorage.deliveryDate = "";
        this.deliveryDate = "";
        this.displayDeliveryDate = this.$t('delivery_date_selector_heading');
        this.disableSaveButton = true;
      }

      this.disabledDeliveryDate = !this.deliveryTown.name;
      if (this.isObjectNotEmpty(this.deliveryTown)) {
        await this.getCutoff();

        if (this.$route.params["sku"]) {
          this.showDateSelector = true;
          this.showSlideOver = true;
          // check the device (tailwind sm - 640px)
          if (window.innerWidth < 640) {
            this.toggleBodyScrolling();
          }
        }
      }

      if (!this.deliveryDate) {
        this.displayDeliveryDate = this.$t('delivery_date_selector_heading')
      }
    },
  },
  async created() {
    this.$dayjs.locale(this.$i18n.locale);
    // TODO refactor the code
    let self = this;
    window.addEventListener("click", function (e) {
      if (!self.$el.contains(e.target) && !(e.target.id === "add_to_basket_btn")) {
        self.showDateSelector = false;
      }
    });
    if (sessionStorage.deliveryDate) {
      this.deliveryDate = sessionStorage.deliveryDate;
      this.displayDeliveryDate = this.isMobile
        ? this.$dayjs(this.deliveryDate).format("MMM Do")
        : this.$dayjs(this.deliveryDate).format("ddd, MMMM Do");
      this.$nuxt.$emit("deliveryDateUpdated", this.deliveryDate);
    }
    if (this.isObjectNotEmpty(this.deliveryTown)) {
      await this.getCutoff();
    }

    this.occasions = await this.getOccasions();
    this.disabledDeliveryDate = !this.isObjectNotEmpty(this.deliveryTown)
    this.isDateInputStyle = this.$route.fullPath.includes('collection');

    // add specific logic for product page to open calendar in default empty date
    if (this.isObjectNotEmpty(this.deliveryTown) && this.$route.params["sku"] && this.deliveryDate === "") {
      this.showDateSelector = true;
      this.showSlideOver = true;
      // check the device (tailwind sm - 640px)
      if (window.innerWidth < 640) {
        this.toggleBodyScrolling();
      }
    }
  },
  methods: {
    dateChangeDesktop(date) {
      this.sendToDataLayer();
      this.deliveryDate = date;
      this.confirmDate();
      this.$nuxt.$emit("deliveryDateUpdated", date);
    },
    dateChangeMobile(date) {
      this.sendToDataLayer();
      this.deliveryDate = date;
      this.disableSaveButton = false;
      this.$nuxt.$emit("deliveryDateUpdated", date);
    },
    confirmDate() {
      this.displayDeliveryDate = this.isMobile
        ? this.$dayjs(this.deliveryDate).format("ddd, MMM Do")
        : this.$dayjs(this.deliveryDate).format("ddd, MMMM Do");
      this.showDateSelector = false;
      sessionStorage.deliveryDate = this.deliveryDate;
      this.$emit("select-delivery-date", this.deliveryDate);
      this.toggleBodyScrolling();
    },
    toggleShowDateSelector(device) {
      // TODO refactor the code
      const ele = document.getElementById("city_selector");
      if (ele !== null) {
        return;
      }
      if (!this.disabledDeliveryDate) {
        this.showDateSelector = !this.showDateSelector;
        this.showSlideOver = true;
      }
      if (device === 'mobile') {
        this.toggleBodyScrolling();
      }
    },
    closeSlideOver() {
      this.disabledDeliveryDate = false;
      this.showDateSelector = false;
      this.showSlideOver = false;
      this.toggleBodyScrolling();
    },
    async getCutoff() {
      this.isLoading = true;
      try {
        this.cutoffs = await this.$axios.$get(
          `v3/region/cutoff/${this.deliveryTown.regionTag}`,
          {
            headers: {
              "callia-lang": this.$i18n.getLocaleCookie(),
            },
          }
        );

        this.closedDays = this.cutoffs.closedDates.map((closeD) => parseInt(closeD));
        const cutoffDateResponse = this.processDateRestrictions(this.cutoffs);
        this.nextAvailableDate = this.findNextAvailableDate(this.$dayjs().format(), { ...cutoffDateResponse, finalCloseDays: this.closedDays }).format("YYYY-MM-DD");

        if (this.$dayjs(this.nextAvailableDate) < this.$dayjs(this.startDate)) {
          this.nextAvailableDate = this.$dayjs(this.startDate).format("YYYY-MM-DD");
        }

        this.closedDays = this.closedDays;
        this.unavailableDates = cutoffDateResponse.finalUnavailableDates;
        this.availableDates = cutoffDateResponse.finalAvailableDates;
        this.cutoffCountdown = this.cutoffs.cutoff_countdown
        if (this.setNxtAvailableDate && !sessionStorage.deliveryDate) {
          sessionStorage.deliveryDate = this.nextAvailableDate;
          this.dateChangeDesktop(this.nextAvailableDate);
        }
        this.isLoading = false;
      } catch (error) {
        console.error(error);
      }
    },
    isObjectNotEmpty(obj) {
      return Object.keys(obj).length > 0;
    },
    toggleBodyScrolling() {
      let body = document.body;
      body.style.overflow = (!this.showDateSelector) ? 'auto' : 'hidden';
    },
    sendToDataLayer() {
      window.dataLayer?.push({
        event: "date_selection",
        first_item: sessionStorage.cartItems === undefined,
        has_selected: this.deliveryDate !== ""
      });
    }
  }
}
